import React, {useState} from 'react';
import {useIntl} from 'react-intl';

import Input from 'components/input';

import './styles.scss';
import {ButtonVariant, GritxButton} from '@wholesalechange/chatcomponent';
import InputRadio from '../../input-radio';
import {IRadioInput} from '../../input-radio/interfaces';

type FilterBarProps = {
  onChangeSearchString: (value: string) => void;
  onChangeFavorites: (value: string) => void;
  onClearAll: () => void;
};

export const CmFilterBar = ({
  onChangeSearchString, onChangeFavorites, onClearAll
}: FilterBarProps): JSX.Element => {
  const intl = useIntl();
  const [searchString, setSearchString] = useState<string>('');
  const [favorites, setFavorites] = useState<string>('false');

  const favoritesRadioInputs: IRadioInput[] = [
    {
      id: 0,
      name: 'All',
      label: 'All',
      value: 'false'
    },
    {
      id: 1,
      name: 'favorites',
      label: 'Favorites',
      value: 'true'
    }];

  function handleKeyUp(e: React.KeyboardEvent) {
    if (e.key === 'Enter') {
      onChangeSearchString(searchString);
    }
  }

  function handleChangeSearchString(value: string) {
    setSearchString(value);
  }

  function handleChangeRadio(value: string) {
    setFavorites(value);
    onChangeFavorites(value);
  }

  function handleClear() {
    setSearchString('');
    setFavorites('false');
    onClearAll();
  }

  return <div className="cm-filter-bar">
    <div className="cm-filter-bar__favorites">
      <InputRadio inputs={favoritesRadioInputs}
        value={favorites}
        onChange={handleChangeRadio}
        label=""/>
    </div>
    <div className="cm-filter-bar__search">
      <Input
        className={'cm-filter-bar__search-field'}
        value={searchString}
        placeholder={intl.formatMessage({
          id: 'gritx.cmresource.search.placeholder',
          defaultMessage: 'Search all resources by keywords or just any words'
        })}
        onChange={handleChangeSearchString}
        onKeyUp={handleKeyUp}
      />
    </div>
    <div className="cm-filter-bar__clear-btn">
      <GritxButton
        title={intl.formatMessage({
          id: 'gritx.cmresource.filter.clearAll',
          defaultMessage: 'Clear All'
        })}
        variant={ButtonVariant.Outline}
        onClick={handleClear}
      />
    </div>
  </div>;
};
